export const booking = {
    CREATE_BOOKING_SUCCESS: 'CREATE_BOOKING_SUCCESS',
    CREATE_BOOKING_FAILURE: 'CREATE_BOOKING_FAILURE',
    CREATE_BOOKING_LOADING: 'CREATE_BOOKING_LOADING',
    SET_FAILED_BOOKING_SLOTS: 'SET_FAILED_BOOKING_SLOTS',
    SET_SUCCESSFUL_BOOKINGS: 'SET_SUCCESSFUL_BOOKINGS',
    CLEAR_BOOKING: 'CLEAR_BOOKING',
}
  
